/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {makeLocaleStaticProps} from 'web_core/utils/static_props';
import {DefaultLayout} from '~/components/Layout/Default';
export const getStaticProps = makeLocaleStaticProps;
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2",
    ul: "ul",
    li: "li"
  }, props.components);
  return _jsx(DefaultLayout, {
    headerMenu: false,
    maxWidth: 1000,
    head: {
      title: `プライバシーポリシー`,
      description: "本プライバシーポリシーは、本サービスを通じた運営による個人情報の取得及び取扱いに関する方針を説明するものです。"
    },
    children: _jsxs("div", {
      className: "mathdown-monotone",
      children: [_jsx(_components.h1, {
        children: "Mathlog プライバシーポリシー"
      }), _jsx(_components.p, {
        children: "本プライバシーポリシーは、本サービスを通じた運営による個人情報の取得及び取扱いに関する方針を説明するものです。本サービスをご利用いただいた場合、本規約に同意していただいたものとみなされます。"
      }), _jsx(_components.h2, {
        children: "個人情報取り扱いに関する基本方針"
      }), _jsx(_components.p, {
        children: "運営は本サービスを提供するにあたり、必要最小限の個人情報を Google Analytics などの解析ツールや Cookie、投稿内容から取得します。そして、個人情報は法令や本規約を遵守し、適正に取り扱うことをお約束します。"
      }), _jsx(_components.h2, {
        children: "個人情報の利用目的"
      }), _jsx(_components.p, {
        children: "運営は、本サービスの提供・開発・改善のために、個人情報を利用します。利用目的には以下が含まれます。"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "法令遵守"
        }), "\n", _jsx(_components.li, {
          children: "運営からのご連絡"
        }), "\n", _jsx(_components.li, {
          children: "広告の最適化および配信"
        }), "\n", _jsx(_components.li, {
          children: "アンケートの依頼"
        }), "\n", _jsx(_components.li, {
          children: "本サービスにおける本人確認"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "本利用目的を超えて個人情報を利用することはありません。"
      }), _jsx(_components.h2, {
        children: "個人情報の第三者提供について"
      }), _jsx(_components.p, {
        children: "運営が第三者に個人情報を提供する際には、個人情報保護法に従い以下に該当する場合を除いては、個人情報保護委員会に届け出をすることをお約束します"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "法令に基づく場合"
        }), "\n", _jsx(_components.li, {
          children: "人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき。"
        }), "\n", _jsx(_components.li, {
          children: "公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき。"
        }), "\n", _jsx(_components.li, {
          children: "国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "また運営は、ユーザ情報を第三者との間で共同して利用する場合は、対象となる登録ユーザに、以下の情報を容易に知り得る状態に置き、又は通知します。"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "共同利用を行うことについて"
        }), "\n", _jsx(_components.li, {
          children: "共同して利用する者の範囲"
        }), "\n", _jsx(_components.li, {
          children: "共同して利用する個人情報の項目"
        }), "\n", _jsx(_components.li, {
          children: "共同利用する個人情報の管理責任者"
        }), "\n", _jsx(_components.li, {
          children: "共同利用する個人情報の取得方法"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "第三者提供に関する免責"
      }), _jsx(_components.p, {
        children: "以下の場合は、第三者による個人情報の取得に関し、当運営は一切の責任を負いません。"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "登録ユーザ自身が本サービスの機能または別の手段を用いて個人情報を明らかにする場合"
        }), "\n", _jsx(_components.li, {
          children: "本サービスに入力した情報により、期せずして本人が特定できてしまった場合"
        }), "\n", _jsx(_components.li, {
          children: "本サービスからリンクされる外部サイトにおいて、ユーザより個人情報が提供され、またそれが利用された場合"
        }), "\n", _jsx(_components.li, {
          children: "ユーザ本人以外がユーザ個人を識別できる情報（ID・パスワード等）を入手した場合"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "個人情報の開示、訂正等の手続きについて"
      }), _jsx(_components.p, {
        children: "登録ユーザ自らが、運営が取得した個人情報に関して開示・訂正・追加・削除等を希望される場合は、公式 Twitter の DM もしくはメールアドレス support@mathlog.info にご連絡ください。お問い合わせの際には、本人確認をさせていただきますので、あらかじめご了承ください。"
      }), _jsx(_components.h2, {
        children: "改定について"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "改定日：2025 年 1 月 30 日 問い合わせ先メールアドレスを変更"
        }), "\n", _jsx(_components.li, {
          children: "改定日：2024 年 1 月 7 日 プレミアム機能に関する内容を追加"
        }), "\n", _jsx(_components.li, {
          children: "改定日：2023 年 5 月 18 日 一部機能の名前を変更"
        }), "\n", _jsx(_components.li, {
          children: "改定日：2021 年 5 月 1 日 決済に関して追記"
        }), "\n", _jsx(_components.li, {
          children: "改定日：2021 年 1 月 1 日"
        }), "\n", _jsx(_components.li, {
          children: "制定日：2020 年 11 月 6 日"
        }), "\n"]
      })]
    })
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
